import ApiService from "@/plugins/ApiService";
import { SET_LOADING, SET_MEDIA_FILES } from "@/store/mutation-types";
import { FETCH_MEDIA_FILES } from "@/store/action-types";


const state = {

    media_files: [],
    data: {},
}




const mutations = {

    [SET_MEDIA_FILES](state, response) {

        state.media_files = response
        state.data = response.data
    }

}


const actions = {

    [FETCH_MEDIA_FILES]({ commit }, items) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {
            ApiService.query('admin/files', items)
                .then(response => {
                    commit(SET_MEDIA_FILES, response.data)
                    commit(SET_LOADING, false)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })

        })
    },





}

export default {
    state,
    mutations,
    actions
}